import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './ReadOnlyBanner.css';

const API_URL = process.env.REACT_APP_API_URL || '';

function ReadOnlyBanner() {
  const { t } = useTranslation();
  const [isReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    fetch(`${API_URL}/api/instance-info`)
      .then(res => res.json())
      .then(data => {
        if (data.readOnlyInstance) {
          setIsReadOnly(true);
        }
      })
      .catch(() => {
        // Ignore — older backend without this endpoint
      });
  }, []);

  if (!isReadOnly) return null;

  return (
    <div className="readonly-banner">
      <div className="readonly-banner-content">
        <span className="readonly-banner-icon">&#128274;</span>
        <span className="readonly-banner-text">
          <strong>{t('components.readOnlyBanner.title')}</strong> — {t('components.readOnlyBanner.message')}
        </span>
      </div>
    </div>
  );
}

export default ReadOnlyBanner;
